import {useEffect} from "react";
import isEmpty from "is-empty";
import {usePage} from "@inertiajs/react";
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";
import {isMobile} from "@/Helpers/Function";

export default function useShowContinueApplication() {
    const {props} = usePage();
    const {mobileApp = false, continueApplication = {}} = props;
    const {modalStore = {}} = useStoreMobx();

    useEffect(() => {
        const application = sessionStorage.getItem('continueApplication');
        if (!isEmpty(continueApplication) && !mobileApp && isMobile() && application === null) {
            modalStore.openApplicationDrawer();
        }
    }, []);
}
